<div *transloco="let t">
	<div id="coAppOfferedOuterDiv" class="status-co-app-offered">
		<div class="header-section">
			<header class="op-header-1">{{ t('CO_APP.OFFER.ADD_COAPPLICANT.header') }}</header>
			<div class="op-light-black">
				<p>{{ t('CO_APP.OFFER.ADD_COAPPLICANT.description') }}</p>
			</div>
		</div>

		<section class="benefits" id="benefits-section">
			<header class="op-header-3">{{ t('CO_APP.OFFER.BENEFITS.header') }}</header>
			<div class="body op-light-black">
				<label>{{
					needStrongCredit ? t('CO_APP.OFFER.BENEFITS.betterApproval') : t('CO_APP.OFFER.BENEFITS.goodCredit')
				}}</label>
				<div class="foot-note">
					<mat-icon svgIcon="op-checkMark-rounded"></mat-icon>
					<label>{{ t('CO_APP.OFFER.BENEFITS.betterApprovalChance') }}</label>
				</div>
			</div>
		</section>

		<section class="requirements" id="requirements-section">
			<mat-expansion-panel expanded="false">
				<mat-expansion-panel-header>
					<mat-panel-title class="op-header-3"> {{ t('CO_APP.OFFER.REQUIREMENTS.header') }}</mat-panel-title>
				</mat-expansion-panel-header>
				<div class="op-body-1-font op-mt-16">
					<ul class="requirements-list">
						<li>{{ t('CO_APP.OFFER.REQUIREMENTS.noActiveLoan') }}</li>
						<li>{{ t('CO_APP.OFFER.REQUIREMENTS.above18') }}</li>
						<li>{{ t('CO_APP.OFFER.REQUIREMENTS.noPriorLoan') }}</li>
						<li>{{ t('CO_APP.OFFER.REQUIREMENTS.sameState') }}</li>
					</ul>
					<div class="op-mt-16 disclaimer op-label">
						<label>{{ t('CO_APP.OFFER.REQUIREMENTS.disclaimer') }}</label>
					</div>
				</div>
			</mat-expansion-panel>
		</section>

		<section class="next-steps" id="next-steps-section" *ngIf="!enableCoAppInvite">
			<mat-expansion-panel expanded="false">
				<mat-expansion-panel-header>
					<mat-panel-title class="op-header-3"> {{ t('CO_APP.OFFER.NEXT_STEPS.header') }}</mat-panel-title>
				</mat-expansion-panel-header>
				<div class="op-body-1-font op-light-black op-mt-16 body">
					<div class="step">
						<mat-icon svgIcon="op-call"></mat-icon>
						<label>{{ t('CO_APP.OFFER.NEXT_STEPS.callCustomerService') }}</label>
					</div>
					<div class="step">
						<mat-icon svgIcon="op-user-verified"></mat-icon>
						<label>{{ t('CO_APP.OFFER.NEXT_STEPS.inviteCoApplicant') }}</label>
					</div>
					<div class="step">
						<mat-icon svgIcon="op-together"></mat-icon>
						<label>{{ t('CO_APP.OFFER.NEXT_STEPS.completeLoanTogether') }}</label>
					</div>
				</div>
			</mat-expansion-panel>
		</section>

		<section class="next-steps" id="next-steps-section" *ngIf="enableCoAppInvite">
			<mat-expansion-panel expanded="false">
				<mat-expansion-panel-header>
					<mat-panel-title class="op-header-3"> {{ t('CO_APP.OFFER.NEXT_STEPS.header') }}</mat-panel-title>
				</mat-expansion-panel-header>
				<div class="op-body-1-font op-light-black op-mt-16 body">
					<div class="step">
						<mat-icon svgIcon="op-paper-plane-green"></mat-icon>
						<label>{{ t('CO_APP.OFFER.NEXT_STEPS.inviteCoApplicantWithRequirements') }}</label>
					</div>
					<div class="step">
						<mat-icon svgIcon="op-user-verified"></mat-icon>
						<label>{{ t('CO_APP.OFFER.NEXT_STEPS.invitationLetter') }}</label>
					</div>
					<div class="step">
						<mat-icon svgIcon="op-together"></mat-icon>
						<label>{{ t('CO_APP.OFFER.NEXT_STEPS.completeLoanTogether') }}</label>
					</div>
				</div>
			</mat-expansion-panel>
		</section>

		<section class="reapply-solo" id="reapply-solo-section">
			<mat-expansion-panel expanded="false">
				<mat-expansion-panel-header>
					<mat-panel-title class="op-header-3"> {{ t('CO_APP.OFFER.REAPPLY_SOLO.header') }}</mat-panel-title>
				</mat-expansion-panel-header>
				<div class="op-body-1-font op-mt-16 body">
					<div class="reapply-solo-inner op-body-1">
						<label>{{
							t('CO_APP.OFFER.REAPPLY_SOLO.description', { newApplicationStartDate: newApplicationStartDate })
						}}</label>
					</div>
					<div class="foot-note op-micro">
						<label>{{ t('CO_APP.OFFER.REAPPLY_SOLO.footnote') }}</label>
					</div>
				</div>
			</mat-expansion-panel>
		</section>

		<op-co-app-common-questions
			id="op-co-app-common-questions"
			[questionType]="questionTypeEnum.OFFER"
		></op-co-app-common-questions>
	</div>

	<footer id="footer-section">
		<div class="op-center" [ngClass]="isFooterVisible ? 'button-container' : 'floating-button-container'">
			<button
				*ngIf="enableCoAppInvite"
				class="op-full-width floating-button"
				mat-flat-button
				color="primary"
				name="inviteCoAppBtn"
				id="inviteCoAppBtn"
				[opTagClick]="'co-app-invite call-us'"
				(click)="inviteCoApplicant()"
				type="button"
			>
				{{ t('CO_APP.OFFER.BUTTON.inviteCoApplicant') }}
			</button>

			<button
				*ngIf="!enableCoAppInvite"
				class="op-full-width floating-button"
				mat-flat-button
				color="primary"
				name="callNowBtn"
				id="callNowBtn"
				[opTagClick]="'co-app-invite call-us'"
				(click)="callUs()"
				type="button"
			>
				{{ t('CO_APP.OFFER.BUTTON.callUs') }}
			</button>
		</div>
	</footer>

	<div class="op-mt-20">
		<button
			class="op-full-width"
			mat-flat-button
			color="secondary"
			name="doItLater"
			id="doItLater"
			[opTagClick]="'co-app-invite do-it-later'"
			(click)="doItLater()"
			type="button"
		>
			{{ t('CO_APP.OFFER.BUTTON.later') }}
		</button>

		<div class="op-mt-8 disclaimer">
			<label class="op-light-black op-micro">{{ t('CO_APP.OFFER.FOOTER.disclaimer') }}</label>
		</div>
	</div>
</div>
